<template>
    <div class="story-maker-sticker-menu-link-facebook">
        <div class="backdrop" @click="cancel"></div>
        <div class="card">
            <div class="card-header">
                <p class="panel-title">{{ $t('dash.post-creator.story.link-button-add-text') }}</p>
                <i class="fa-solid fa-xmark" @click="cancel"></i>
            </div>

            <div class="content">
            <label class="radio-option">
                <span>{{ $t('dash.post-creator.story.link-button-shop-title') }}</span>
                <input type="radio" value="shop" v-model="models.mode">
            </label>
            <p class="hint" v-if="models.mode === 'shop'">{{ $t('dash.post-creator.story.link-button-shop-description') }}</p>

            <div class="divider"></div>

            <label class="radio-option">
                <span>{{ $t('dash.post-creator.story.link-button-website-title') }}</span>
                <input type="radio" value="website" v-model="models.mode">
            </label>

            <template v-if="models.mode === 'website'">
                <div class="link-field">
                    <SelectComponent
                        :changeValueSelect="changeButtonType"
                        :data="linkButtonTypes"
                        :valueSelect="models.buttonType"
                        :positionAuto="false" :positionX="'left'">
                    </SelectComponent>
                </div>

                <div class="link-field">
                    <i class="fa-regular fa-link"></i>
                    <input :placeholder="$t('dash.post-creator.story.url-placeholder')" v-model="models.link" class="input-link">
                </div>
                <p class="error">{{ error }}</p>
            </template>

            <div class="button" @click="finish">
                {{ $t('dash.post-creator.story.add-button') }}
            </div>

            <div class="btn-remove-link" v-if="editingSticker && editingSticker.id" @click="remove">
                <i class="fa-solid fa-trash-can"></i>
                <span>{{ $t('dash.post-creator.story.link-remove-text') }}</span>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectComponent from '@/components/dash/utils/select.vue'
import { facebookLinkButtonTypeLabels, FACEBOOK_WEBSITE_BUTTON_TYPES, FACEBOOK_LINK_DEFAULT_BUTTON_TYPE } from '../../facebookLinkButtonTypes.js'

export default {
    components: {
        SelectComponent,
    },

    props: {
        editingSticker: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            models: {
                mode: 'shop',
                link: '',
                buttonType: FACEBOOK_LINK_DEFAULT_BUTTON_TYPE,
            },
            error: '',
        }
    },

    computed: {
        linkButtonTypes() {
            return facebookLinkButtonTypeLabels(this.$t.bind(this), FACEBOOK_WEBSITE_BUTTON_TYPES)
        },
    },

    mounted() {
        if (this.editingSticker) {
            this.models.mode = this.editingSticker.mode || 'shop'
            this.models.link = this.editingSticker.link || ''
            this.models.buttonType = FACEBOOK_WEBSITE_BUTTON_TYPES.includes(this.editingSticker.buttonType)
                ? this.editingSticker.buttonType
                : FACEBOOK_LINK_DEFAULT_BUTTON_TYPE
        }
    },

    methods: {
        changeButtonType(value) {
            this.models.buttonType = value
        },

        finish() {
            if (this.models.mode === 'website') {
                this.error = ''
                this.models.link = this.models.link.trim();
                if (!this.validURL(this.models.link) || !this.models.link) {
                    this.error = 'adresse invalide'
                    return
                }
            }

            const data = {
                link: this.models.mode === 'website' ? this.models.link : '',
                styleVariant: 1,
                mode: this.models.mode,
                buttonType: this.models.buttonType,
            }

            if (this.editingSticker && this.editingSticker.id) {
                this.$emit('updateSticker', this.editingSticker.id, { isEditing: false, data })
                this.$emit('changeMenu', false)
            } else {
                this.$emit('addSticker', 'link', { data })
            }
        },

        remove() {
            this.$emit('deleteSticker', this.editingSticker.id)
            this.$emit('changeMenu', false)
        },

        cancel() {
            this.$emit('changeMenu', false)
        },

        validURL(str) {
            if(str == '') return true
            try {
                return Boolean(new URL(str));
            }
            catch(e){
                return false;
            }
        },
    },
}
</script>
